import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-group-offer-list-filters',
	templateUrl: './group-offer-list-filters.component.html',
	styleUrls: ['./group-offer-list-filters.component.css'],
})
export class GroupOfferListFiltersComponent extends FiltersComponent {
	@Input() yesno: Array<any>;
	@Input() products: Array<any>;
	@Input() locations: Array<any>;
	filters = {
		date_range: [],
		product: null,
		location: null,
		stop_sale: null,
		www: null,
		sale: null,
		merlinx: null,
		limit: null,
	};
	protected filtersDefinition = {
		product: {
			type: 'number',
			isArray: true,
		},
		location: {
			type: 'number',
			isArray: true,
		},
	};

	filtersDefault() {
		this.filtersClear();
	}
}
